import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../../config/AuthContext";
import {Button, FloatButton, Form, Input, message, Upload, UploadProps, Image, Tag} from "antd";
import JutgeColors from "../../../../styles/JutgeColors";
import {GetJutgeProblemesId} from "../../../../dao/jutge/GetJutgeProblemesId";
import {PostJutgeProblemaIdUsuariId} from "../../../../dao/jutge/PostJutgeProblemaIdUsuariId";
import ReactMarkdown from "react-markdown";
import {InboxOutlined} from "@mui/icons-material";
import {GetJBbddProblemesId} from "../../../../dao/bbdd/GetJBbddProblemesId";
import BbddColors from "../../../../styles/BbddColors";
import {GetBbddProblemaIdUsuariId} from "../../../../dao/bbdd/GetBbddProblemaIdUsuariId";
import {BiPlus} from "react-icons/bi";
import TextArea from "antd/es/input/TextArea";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import {GetPractica} from "../../../../dao/bbdd/GetPracticaId";
import Editor from "@monaco-editor/react";
import ErDiagramIde from "../../disseny/ErDiagramIde";
import ScriptRelationalIde from "../../disseny/ScriptRelationalIde";
import RelationalDiagramIde from "../../disseny/RelationalDiagramIde";
import { validateErDiagram } from "../../disseny/engine/ErValidator";
import { validateScriptRelational, parseScriptTextToData } from "../../disseny/engine/ScriptRelationalEngine";
import { validateRelationalDiagram } from "../../disseny/engine/RelationalValidator";

const ProblemaIdEnunciat = () => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const {id_problema, id_activitat} = useParams();
    const [dades, setDades] = (useState<any>())
    const [activitat, setActivitat] = (useState<any>())
    const [selectedUid, setSelectedUid] = useState('');
    const [enviado, setEnviado] = useState(true);
    const [loading, setLoading] = useState(false);
    const [respostaAlumne, setRespostaAlumne] = useState([]);
    const [resposta, setResposta] = useState([]);
    const [customConfig, setCustomConfig] = useState<any>(null);
    const [intentsFallits, setIntentsFallits] = useState<number>(0);
    const [penalitzacioPerIntent, setPenalitzacioPerIntent] = useState<number>(0);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_problema]);

    async function checkDades() {
        setLoading(true);
        const data = await GetJBbddProblemesId(id_problema + "");
        setDades(data);

        // Parsejar la configuració de tests/rúbrica del camp checks si n'hi ha
        if (data?.checks) {
            try {
                let jsonPart = data.checks;
                const hashIdx = data.checks.indexOf('#');
                if (hashIdx !== -1 && data.checks.slice(hashIdx + 1).trim().startsWith('{')) {
                    jsonPart = data.checks.slice(hashIdx + 1).trim();
                }
                const parsed = JSON.parse(jsonPart);
                setCustomConfig(parsed);
                if (parsed.penalitzacioPerIntent !== undefined) {
                    setPenalitzacioPerIntent(Number(parsed.penalitzacioPerIntent) || 0);
                }
            } catch (err) {
                const match = data.checks.match(/PENALTY:(\d+(\.\d+)?)/);
                if (match) {
                    setPenalitzacioPerIntent(Number(match[1]) || 0);
                } else {
                    setPenalitzacioPerIntent(0);
                }
                setCustomConfig(null);
            }
        } else {
            setCustomConfig(null);
            setPenalitzacioPerIntent(0);
        }

        if (id_activitat !== undefined) {
            const act = await GetPractica(id_activitat + "");
            setActivitat(act);
        } else {
            setActivitat({isExamen: false});
        }

        // Recuperar l'últim enviament o resposta desada de l'alumne per a aquest problema i comptar intents fallits
        try {
            const envList = await import('../../../../dao/bbdd/GetJBbddProblemesIdEnviament').then(m => m.GetJBbddProblemesIdEnviament(id_problema + "", userId + "", id_activitat));
            if (Array.isArray(envList) && envList.length > 0) {
                // Seleccionar l'últim per carregar-lo a l'IDE
                if (envList[0] && envList[0].actual) {
                    form.setFieldsValue({ resposta: envList[0].actual });
                }

                // Comptar intents fallits reals (sense comptar els simples "DRAFT_GUARDAT")
                const fallits = envList.filter((it: any) => {
                    const isDraft = it.draft || it.errors === 'DRAFT_GUARDAT';
                    if (isDraft) return false;
                    const isOk = (it.salida && it.salida.startsWith('OK')) || it.estat === 1 || it.estat === 2;
                    return !isOk;
                }).length;
                setIntentsFallits(fallits);
            } else {
                setIntentsFallits(0);
            }
        } catch (e) {
            console.warn("No s'ha pogut recuperar l'últim enviament:", e);
        }

        setEnviado(false);
        setLoading(false);
    }

    const {Dragger} = Upload;

    interface ExtendedFile extends File {
        uid: string;
    }

    const props: UploadProps = {
        name: 'file',
        multiple: false,
        onChange(info) {
            const {status} = info.file;
            if (status !== 'uploading') {
                //console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            e.preventDefault();

            const file = e.dataTransfer.files[0] as ExtendedFile;

            // Asumiendo que el archivo tiene una propiedad `uid`:
            const uid = file.uid;
            //console.log(uid);
            setSelectedUid(uid);
        },
        customRequest({file, onSuccess, onError}) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('uid', selectedUid);

            return fetch(`${process.env.REACT_APP_API_URL}:8061/bbdd/problemes/${id_problema}/usuaris/${userId}/upload`, {
                method: 'POST',
                body: formData,
            })
                .then(response => {
                    if (response.ok) {
                        if (onSuccess) onSuccess(file);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    if (onError) onError(error); // Llama a onError en caso de error
                });
        }
    };


    async function submitData(notaOverride?: number) {
        setLoading(true);
        setEnviado(true);
        setResposta([]);
        setRespostaAlumne([]);
        const formData = form.getFieldsValue();
        const respostaActual = selectedUid !== '' ? selectedUid : (formData.resposta || '');

        // IMPORTANT: quan s'envia amb el botó <Button htmlType="submit">, Ant Design crida
        // onFinish(values) passant l'OBJECTE de valors del formulari com a primer argument.
        // Això feia que notaOverride fos un objecte (no undefined) i, per tant, es saltava
        // tota la pre-avaluació de disseny i s'enviava una "nota" no numèrica -> el backend
        // la rebia com a null i guardava sempre estat=CORRECTE (100/100). Només acceptem
        // notaOverride si és realment un número.
        let notaEfectiva: number | undefined = (typeof notaOverride === 'number' && !Number.isNaN(notaOverride))
            ? notaOverride
            : undefined;
        let feedbackJsonToSave: string | undefined = undefined;

        // Si és disseny (ER, Script, Relacional) i no s'ha passat notaOverride (per exemple, en clicar el botó del formulari)
        if (notaEfectiva === undefined && (dades?.tipus === 'ER' || dades?.tipus === 'Script' || dades?.tipus === 'Relacional')) {
            try {
                // IMPORTANT: la solució (correccio) d'un Script pot venir com a TEXT PLA (no JSON).
                // No podem fer JSON.parse a cegues: per a Script només parsegem JSON si comença
                // per '{'; en cas contrari deixem el text tal qual perquè el parsegi l'engine.
                let solObj: any = null;
                if (dades?.correccio) {
                    if (typeof dades.correccio === 'string') {
                        const s = dades.correccio.trim();
                        if (s.startsWith('{')) {
                            try { solObj = JSON.parse(s); } catch (_) { solObj = s; }
                        } else {
                            solObj = s; // text pla (p. ex. Script)
                        }
                    } else {
                        solObj = dades.correccio;
                    }
                }
                if (solObj) {
                    // IMPORTANT: enviem la NOTA BASE (sense penalització per intents). La
                    // penalització s'aplica dinàmicament en mostrar-la, no es desa a la BD.
                    let res: any = null;
                    if (dades?.tipus === 'ER') {
                        const solParsed = typeof solObj === 'string' ? JSON.parse(solObj) : solObj;
                        const stuObj = typeof respostaActual === 'string' ? JSON.parse(respostaActual) : respostaActual;
                        res = validateErDiagram(stuObj, solParsed, customConfig, 0);
                    } else if (dades?.tipus === 'Script') {
                        const stuObj = typeof respostaActual === 'string' && respostaActual.trim().startsWith('{')
                            ? JSON.parse(respostaActual)
                            : parseScriptTextToData(respostaActual);
                        const solParsed = (solObj && solObj.tables && Array.isArray(solObj.tables))
                            ? solObj
                            : (typeof solObj === 'string' ? parseScriptTextToData(solObj) : solObj);
                        res = validateScriptRelational(stuObj, solParsed, customConfig, 0);
                    } else if (dades?.tipus === 'Relacional') {
                        const solParsed = typeof solObj === 'string' ? JSON.parse(solObj) : solObj;
                        const stuObj = typeof respostaActual === 'string' ? JSON.parse(respostaActual) : respostaActual;
                        res = validateRelationalDiagram(stuObj, solParsed, customConfig, 0);
                    }
                    if (res) {
                        notaEfectiva = (res.notaBase !== undefined ? res.notaBase : res.score);
                        // Desarem el detall d'avaluació (feedback/summary/notaBase) a json_alumne.
                        try {
                            feedbackJsonToSave = JSON.stringify({
                                notaBase: res.notaBase !== undefined ? res.notaBase : res.score,
                                feedback: res.feedback || [],
                                summary: res.summary || null,
                                tipus: dades?.tipus
                            });
                        } catch (_) { feedbackJsonToSave = undefined; }
                    }
                }
            } catch (err) {
                console.warn("No s'ha pogut pre-avaluar el disseny abans d'enviar:", err);
            }
        }

        // Si és SQL/NoSQL i no es passa notaOverride, calcular la nota aplicant la penalització
        if (notaEfectiva === undefined && (dades?.tipus === 'SQL' || dades?.tipus === 'NoSQL' || dades?.tipus === 'NOSQL')) {
            const penalitzacioTotal = intentsFallits * penalitzacioPerIntent;
            notaEfectiva = Math.max(0, Math.round(100 - penalitzacioTotal));
        }

        let codeToSubmit = respostaActual;
        const upperTipus = (dades?.tipus || '').toUpperCase();
        if (upperTipus === 'DDL' || upperTipus.includes('DDL')) {
            codeToSubmit = (typeof codeToSubmit === 'string') ? codeToSubmit.replace(/^\s*USE\s+[^;]+;\s*/gim, '').trim() : codeToSubmit;
        } else if (upperTipus === 'SQL' || upperTipus === 'DML' || upperTipus === 'CONSULTA' || upperTipus === 'QUERY') {
            codeToSubmit = (typeof codeToSubmit === 'string') ? codeToSubmit.replace(/^\s*USE\s+[^;]+;\s*/gim, '').trim() : codeToSubmit;
        }

        // Schema real de la BD d'aula vinculada a l'exercici (igual que fa l'IDE). NO enviem
        // mai el NOM de l'exercici com a schema: feia que el backend intentés obrir una
        // connexió a un esquema per-usuari inexistent i l'avaluació fallava des de la web.
        // Si l'exercici no té BD d'aula pròpia, enviem buit perquè el backend resolgui
        // l'esquema (BD per defecte de l'activitat / 'bbdd').
        const schemaForEval = (dades as any)?.aula_database_schema
            || (dades as any)?.aulaDatabaseSchema
            || (dades as any)?.schema_name
            || '';

        const response = await GetBbddProblemaIdUsuariId(
            id_problema + "",
            userId + "",
            codeToSubmit,
            dades?.tipus,
            schemaForEval,
            'avaluar',
            notaEfectiva,
            id_activitat,
            feedbackJsonToSave
        );

        if (id_activitat === undefined || !activitat?.isExamen) {
            const finalScore = notaEfectiva !== undefined ? Math.round(notaEfectiva) : 100;
            const isParcial = (response?.salida && response.salida.startsWith('PARCIAL')) || (notaEfectiva !== undefined && notaEfectiva > 0 && notaEfectiva < 100);
            const isOk = (response?.salida && response.salida.startsWith('OK')) || (notaEfectiva !== undefined && notaEfectiva >= 100);

            if (isOk) {
                if (penalitzacioPerIntent > 0 && intentsFallits > 0) {
                    const penalitzacioTotal = intentsFallits * penalitzacioPerIntent;
                    message.success({
                        content: `TEST OK! Puntuació: ${finalScore}/100 (${intentsFallits} fallits previs, penalització: -${penalitzacioTotal} pts)`,
                        duration: 5
                    });
                } else {
                    message.success(`TEST OK! Puntuació: ${finalScore}/100`);
                }
            } else if (isParcial) {
                setIntentsFallits(prev => prev + 1);
                message.warning({
                    content: `AVALUAT: Parcialment correcte (${finalScore}/100)`,
                    duration: 5
                });
            } else {
                setIntentsFallits(prev => prev + 1);
                message.error(response?.salida || `TEST KO! Puntuació: ${finalScore}/100`);
                try {
                    setResposta(Array.isArray(JSON.parse(response.jsonCorrecte)) ? JSON.parse(response.jsonCorrecte) : []);
                    setRespostaAlumne(Array.isArray(JSON.parse(response.jsonAlumne)) ? JSON.parse(response.jsonAlumne) : []);
                } catch (e) {
                    console.log("ERROR: no es pot obtenir la resposta dels selects");
                }
            }
        } else {
            message.success("Enviat");
        }
        setLoading(false);
        setEnviado(false);
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                <h3 style={{ margin: 0 }}>{dades?.nom}</h3>
                {dades?.tags && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {String(dades.tags).split(/[\s,]+/).filter(Boolean).map((tag: string, idx: number) => (
                            <Tag key={idx} color="blue" style={{ borderRadius: 12 }}>
                                #{tag}
                            </Tag>
                        ))}
                    </div>
                )}
            </div>
            <br/>
            {(() => {
                if (!dades?.img) return null;
                const rawImg = typeof dades.img === 'string' ? dades.img : String(dades.img);
                let imgList: string[] = [];
                if (rawImg.startsWith('[')) {
                    try {
                        const parsed = JSON.parse(rawImg);
                        if (Array.isArray(parsed)) {
                            imgList = parsed;
                        }
                    } catch (e) {
                        imgList = [rawImg];
                    }
                } else if (rawImg.trim().length > 0) {
                    imgList = [rawImg];
                }
                if (imgList.length === 0) return null;

                return (
                    <div style={{ marginBottom: 16 }}>
                        <Image.PreviewGroup>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
                                {imgList.map((imgSrc, idx) => {
                                    const src = imgSrc.startsWith('data:') ? imgSrc : `data:image/png;base64,${imgSrc}`;
                                    return (
                                        <div
                                            key={idx}
                                            style={{
                                                borderRadius: 8,
                                                overflow: 'hidden',
                                                border: '1px solid #d9d9d9',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                                background: '#fafafa',
                                                padding: 4,
                                                display: 'inline-block'
                                            }}
                                        >
                                            <Image
                                                src={src}
                                                alt={`Imatge de l'exercici ${idx + 1}`}
                                                height={dades?.tipus === 'ER' ? 150 : 200}
                                                style={{
                                                    objectFit: 'contain',
                                                    borderRadius: 6,
                                                    display: 'block'
                                                }}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </Image.PreviewGroup>
                        <hr style={{ marginTop: 16 }} />
                    </div>
                );
            })()}
            <p style={{userSelect: "none"}}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                >
                    {dades?.enunciat}
                </ReactMarkdown></p>
            <br/>
            <Form onFinish={submitData} form={form}>
                {dades?.tipus === 'ER' ? (
                    <div style={{ marginBottom: 16 }}>
                        <div style={{
                            height: '62vh',
                            border: '1px solid #d9d9d9',
                            borderRadius: 8,
                            overflow: 'hidden',
                            marginBottom: 12
                        }}>
                            <ErDiagramIde
                                initialData={form.getFieldValue('resposta')}
                                solutionData={dades?.correccio}
                                customConfig={customConfig}
                                intentsFallitsPrevis={intentsFallits}
                                hideEvaluate={true}
                                title={`Disseny ER · ${dades?.nom || ''}`}
                                onSave={(data) => {
                                    form.setFieldsValue({ resposta: JSON.stringify(data) });
                                }}
                                onManualSave={async (data) => {
                                    const jsonStr = JSON.stringify(data);
                                    form.setFieldsValue({ resposta: jsonStr });
                                    try {
                                        await GetBbddProblemaIdUsuariId(
                                            id_problema + "",
                                            userId + "",
                                            jsonStr,
                                            dades?.tipus || 'ER',
                                            dades?.nom || 'consulta',
                                            'guardar',
                                            undefined,
                                            id_activitat
                                        );
                                        message.success('Model ER desat correctament al servidor!');
                                    } catch (err: any) {
                                        message.error("Error en desar al servidor: " + (err?.message || err));
                                    }
                                }}
                            />
                        </div>
                        <Form.Item name="resposta" hidden>
                            <Input />
                        </Form.Item>
                    </div>
                ) : dades?.tipus === 'Script' ? (
                    <div style={{ marginBottom: 16 }}>
                        <div style={{
                            height: '62vh',
                            border: '1px solid #d9d9d9',
                            borderRadius: 8,
                            overflow: 'hidden',
                            marginBottom: 12
                        }}>
                            <ScriptRelationalIde
                                initialData={form.getFieldValue('resposta')}
                                solutionData={dades?.correccio}
                                customConfig={customConfig}
                                intentsFallitsPrevis={intentsFallits}
                                hideEvaluate={true}
                                title={`Script Relacional · ${dades?.nom || ''}`}
                                onSave={(data, formattedText) => {
                                    form.setFieldsValue({ resposta: formattedText });
                                }}
                                onManualSave={async (data, formattedText) => {
                                    const jsonStr = JSON.stringify(data);
                                    form.setFieldsValue({ resposta: formattedText });
                                    try {
                                        await GetBbddProblemaIdUsuariId(
                                            id_problema + "",
                                            userId + "",
                                            formattedText,
                                            dades?.tipus || 'Script',
                                            dades?.nom || 'consulta',
                                            'guardar',
                                            undefined,
                                            id_activitat
                                        );
                                        message.success('Script Relacional desat correctament al servidor!');
                                    } catch (err: any) {
                                        message.error("Error en desar al servidor: " + (err?.message || err));
                                    }
                                }}
                            />
                        </div>
                        <Form.Item name="resposta" hidden>
                            <Input />
                        </Form.Item>
                    </div>
                ) : dades?.tipus === 'Relacional' ? (
                    <div style={{ marginBottom: 16 }}>
                        <div style={{
                            height: '62vh',
                            border: '1px solid #d9d9d9',
                            borderRadius: 8,
                            overflow: 'hidden',
                            marginBottom: 12
                        }}>
                            <RelationalDiagramIde
                                initialData={form.getFieldValue('resposta')}
                                solutionData={dades?.correccio}
                                customConfig={customConfig}
                                intentsFallitsPrevis={intentsFallits}
                                hideEvaluate={true}
                                title={`Model Relacional · ${dades?.nom || ''}`}
                                onSave={(data) => {
                                    form.setFieldsValue({ resposta: JSON.stringify(data) });
                                }}
                                onManualSave={async (data) => {
                                    const jsonStr = JSON.stringify(data);
                                    form.setFieldsValue({ resposta: jsonStr });
                                    try {
                                        await GetBbddProblemaIdUsuariId(
                                            id_problema + "",
                                            userId + "",
                                            jsonStr,
                                            dades?.tipus || 'Relacional',
                                            dades?.nom || 'consulta',
                                            'guardar',
                                            undefined,
                                            id_activitat
                                        );
                                        message.success('Model Relacional desat correctament al servidor!');
                                    } catch (err: any) {
                                        message.error("Error en desar al servidor: " + (err?.message || err));
                                    }
                                }}
                            />
                        </div>
                        <Form.Item name="resposta" hidden>
                            <Input />
                        </Form.Item>
                    </div>
                ) : (
                    <>
                        <Form.Item label="resposta" name="resposta"
                                   rules={[{required: true, message: 'La resposta no pot estar en blanc'}]}>
                            <Editor
                                height="32vh"
                                defaultLanguage={dades?.tipus === 'NoSQL' ? 'json' : 'sql'}
                                language={dades?.tipus === 'NoSQL' ? 'json' : 'sql'}
                                theme="vs-light"
                                options={{ readOnly: false, minimap: { enabled: false }, fontSize: 13 }}
                            />
                        </Form.Item>
                    </>
                )}
                <hr/>
                <Form.Item>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        <Button style={{backgroundColor: BbddColors.colors.color6, color: '#fff', border: 'none', fontWeight: 600}} htmlType="submit"
                                loading={enviado} disabled={enviado}>
                            Enviar & Avaluar
                        </Button>
                    </div>
                </Form.Item>
            </Form>
            <br/>
            <br/>
            {(resposta?.length > 0 || respostaAlumne?.length > 0) &&
                <div style={{ padding: "10px" }}>
                    {/* Renderizar resposta */}
                    {resposta?.length > 0 && (
                        <div>
                            <h3>Resposta</h3>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                <tr>
                                    {Object.keys(resposta[0]).map((key) => (
                                        <th key={key} style={{ padding: "8px", background: "#f0f0f0", border: "1px solid black" }}>
                                            {key}
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {resposta.map((item, index) => (
                                    <tr key={index}>
                                        {Object.values(item).map((value, idx) => (
                                            <td key={idx} style={{ padding: "8px", border: "1px solid black" }}>
                                                {String(value)}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Renderizar respostaAlumne */}
                    {respostaAlumne?.length > 0 && (
                        <div>
                            <h3>Resposta Alumne</h3>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                <tr>
                                    {Object.keys(respostaAlumne[0]).map((key) => (
                                        <th key={key} style={{ padding: "8px", background: "#f0f0f0", border: "1px solid black" }}>
                                            {key}
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {respostaAlumne.map((item, index) => (
                                    <tr key={index}>
                                        {Object.values(item).map((value, idx) => (
                                            <td key={idx} style={{ padding: "8px", border: "1px solid black" }}>
                                                {String(value)}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            }
        </>
    );
};

export default ProblemaIdEnunciat;
